import { useDispatch, useSelector } from "react-redux";
import {
  SubmitApprovalRequestAction,
  ViewRequestStatusAction,
} from "../../../redux/actions/GlobalAction";
import { getProfileDetails } from "../../../redux/actions/ProfileDetailsAction";
import ProfileDetails from "./ProfileDetails";
import UserBranchDetails from "./UserBranchDetails";
import ROUTES from "../../../Utils/routesConstants";
import { getProviderPortalId } from "../../../Utils/types";
import { addProviderAssitLogAction } from "../../../redux/actions/ProviderAssistAction";
import { useParams } from "react-router-dom";

const ProfileDetail = () => {
  const dispatch = useDispatch();
  const urlParams = useParams();
  localStorage.setItem("campaignsToken", urlParams?.token);
  const isShowSubmitButton = useSelector(
    (state) => state.ProfileDetailsReducer.getProfileDetails?.isShowSubmitButton
  );
  const isPageEdit = useSelector((state) => state?.globalReducer?.isPageEdit);
  return (
    <div className="right-section">
      <div className="card profile-details-section">
        <div className="card-body">
          <ProfileDetails />
          {/* <UserBranchDetails /> */}
          <div className="mt-4 mb-2 text-end">
            {isShowSubmitButton && !isPageEdit && (
              <button
                className="btn btn-primary"
                type="button"
                onClick={async () => {
                  await dispatch(SubmitApprovalRequestAction("ProfileDetail"));
                  await dispatch(getProfileDetails());
                  await dispatch(ViewRequestStatusAction("ProfileDetail"));
                  window.location.pathname.includes(ROUTES.PROVIDER_ASSIST) &&
                  (await dispatch(
                    addProviderAssitLogAction({
                      providerId: getProviderPortalId(),
                      moduleName: "ProfileDetail",
                      actionFlag: "S",
                    })
                  ));
                }}
              >
                SUBMIT
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileDetail;
